import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import Nosotros from "@/pages/nosotros/page";
import Proyectos from "@/pages/proyectos/page";
import CarmenDeHuechuraba from "@/pages/proyectos/carmen-de-huechuraba/page";
import Inversion from "@/pages/inversion/page";
import Contacto from "@/pages/contacto/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/nosotros",
    element: <Nosotros />,
  },
  {
    path: "/proyectos",
    element: <Proyectos />,
  },
  {
    path: "/proyectos/carmen-de-huechuraba",
    element: <CarmenDeHuechuraba />,
  },
  {
    path: "/inversion",
    element: <Inversion />,
  },
  {
    path: "/contacto",
    element: <Contacto />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;